/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Card, Grid, Icon, Modal, Notification, TextArea, Tooltip} from '@scuf/common';
import Loader from '../common/Loader'
import * as FaultActions from "./FaultActions";
import * as SecurityActions from "../security/SecurityActions"
import ActionLogTable from "./common/ActionLogTable";
import CommentsTable from "./troubleshooting/CommentsTable";
import ExpandableCard from "../common/ExpandableCard"
import {ACCESS, CORRECTIVE_ACTION_STATE, FAULT_STATES, isClosedState} from "./common/FaultsConst"
import {getBreadcrumbItemsFault, getCurrentLanguage, getFaultName, verifyAirtimeException} from "../utils/Helpers";
import {formatDateTime} from "../common/LocaleHelper";
import BreadCrumb from '../common/Bradcrumb'
import ActionsDropdown from './common/ActionsDropdown'
import ErrorTitle from '../common/ErrorTitle'
import workflowImageEn from '../styling/images/workflow-en.png'
import workflowImageZh from '../styling/images/workflow-zh.png'
import {showNotification} from "../common/ToastNotification";
import {Link} from "react-router-dom";
import momentTz from "moment-timezone";
import SimilarFaultCards from "./similarFaults/SimilarFaultCards";
import ConfigurationSymptoms from "./ConfigurationSymptoms";
import {userHasActivity, userHasRole} from "../security/SecurityUtils";
import {ACTIVITY_TYPES, ROLES} from "../security/SecurityConst";
import * as Assets from "../api/Assets";
import * as Airtime from '../api/Airtime'
import {getUIconfigs, UIconfigNames} from '../api/UIconfig'
import {reexportLLPacket} from "../admin/learningLoop/LearningLoopActions";
import {
    verifySummaryState,
    getFaultSummary,
    immutableFaultState,
    getClosingReasonFromComments
} from "./common/FaultsUtils";
import {fetchCloseComments} from "../api/Faults";
import _ from "lodash";

class FaultDetail extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            comment: '',
            closeComment: '',
            commentsLoading: false,
            workflowModalOpen: false,
            closeModalOpen: false,
            editingDisabled: true,
            affectedFaults: [],
            localLoading: false,
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
            UIconfig_ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON: false,
            closedPredefinedReasons : [],
            closedSelectedReason:'',
        }

        this.handleCommentChange = this.handleCommentChange.bind(this)
        this.handleSaveComment = this.handleSaveComment.bind(this)
        this.handleUpdateComment = this.handleUpdateComment.bind(this)
        this.goToTroubleshooting = this.goToTroubleshooting.bind(this)
        this.goToWorkplan = this.goToWorkplan.bind(this)
        this.setPrimarySymptomAgain = this.setPrimarySymptomAgain.bind(this)
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        this.props.FaultActions.setAssetFault(params.assetId, params.faultId)
        this.reloadFaultCondition(params.assetId, params.faultId)
        getUIconfigs([UIconfigNames.ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON]).then((response) => {
            this.setState({UIconfig_ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON: response.length === 0 ? false : response[0].status === 'ACTIVE'})
        })
        this.fetchCloseCommentsOptions();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps === null || this.props.fault.details === null) {
            return
        }
        if ((!_.isEqual(prevProps.fault.comments, this.props.fault.comments) || prevState.closedPredefinedReasons.length !== this.state.closedPredefinedReasons.length)
                && this.props.fault.details.faultConditionState === 'CLOSED_RESOLVED' && this.state.closedSelectedReason === '') {
            // Check and update the closing reason when fault is closed due to predefined reason, Similar implementation is in Troubleshooting page.
            this.setState({closedSelectedReason: getClosingReasonFromComments(this.props, this.state.closedPredefinedReasons)})
        }

        if (prevProps.match.params && !_.isEqual(prevProps.match.params, this.props.match.params)) {
            this.reloadFaultCondition(this.props.match.params.assetId, this.props.match.params.faultId)
        }
    }

    fetchCloseCommentsOptions() {
        fetchCloseComments()
            .then(response => {
                const options = response.map((opt) => opt.name)
                this.setState({closedPredefinedReasons: options})
            });
    }

    isUserAssigned() {
        return this.props.fault.details.assignedUser !== null && this.props.fault.details.assignedUser.id === this.props.security.userProfile.id
    }

    reloadFaultCondition(assetId, faultId) {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.fetchDetails(assetId, faultId, external).then(
            () => {
                if (this.props.fault.error === null) {
                    this.props.FaultActions.fetchActionLog(assetId, faultId, external).catch(ex => {
                        verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                    })
                    this.props.FaultActions.fetchComments(assetId, faultId, external).catch(ex => {
                        verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                    })
                    this.props.FaultActions.setReadOnly(
                        !isClosedState(this.props.fault.details.faultConditionState) && (
                            this.props.fault.details.faultConditionState === FAULT_STATES.ON_HOLD ||
                            !this.isUserAssigned() || this.props.fault.details.access !== ACCESS.WRITE))
                }
                this.props.FaultActions.fetchActions(assetId, faultId, external).catch(ex => {
                        verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
            }
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    reloadComments(id) {
        this.setState({commentsLoading: true})
        return this.props.FaultActions.fetchComments(this.props.fault.assetId, id, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            this.setState({commentsLoading: false})
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    handleCommentChange(value) {
        this.setState({comment: value})
    }

    handleSaveComment() {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.saveComment(this.props.fault.assetId, this.props.fault.faultId, this.state.comment, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId).then(() => {
                    this.setState({comment: ''})
                })
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    handleUpdateComment(id, text, commentSaved) {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.updateComment(this.props.fault.assetId, this.props.fault.faultId, id, text, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId);
                commentSaved()
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(err => {
            verifyAirtimeException(err.errorKey, this.props.SecurityActions.signOut)
            showNotification({
                translationPropertyKey: 'fault.detail.comment.save.' + err.errorKey,
                severity: "critical",
            })
        });
    }

    getRepeatFaults(symptom, repeatFaults, assetId) {
        const result = repeatFaults.map(rf => {
            if (rf.primarySymptom === symptom.id) {
                const path = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
                    `/airtime/asset/${assetId}/faults/${rf.id}`
                    :
                    `/assets/${assetId}/faults/${rf.id}`

                return (
                    <div className="repeatFault-button">
                        <Link to={path} target="_self">
                            <Button type="link">{rf.name + ":" + symptom.name}</Button>
                        </Link>
                        <span className="timeAgo-message">
                            {this.toTimeAgo(rf.closeDateTime)}
                        </span>
                    </div>
                )
            } else {
                return null;
            }
        })
        if (result != null && result[0] != null) {
            return (
                <div>
                    <div className="icon-repeat">
                        <Icon className="yellow-icon" name="badge-info" exactSize={35}/>
                        <div className="yellow-text">
                            <FormattedMessage id={"fault.detail.repeatFault"}/>
                        </div>
                    </div>
                    {result}
                    <br/>
                </div>
            )
        }
        return null;
    }

    toTimeAgo(closeDateTime){
        // TO DO: Re-do for localization!!
        let difference = (new Date() - momentTz.tz(closeDateTime, 'UTC').toDate()) / 1000;
        let element = "";
        if (difference < 60) {
            element = "second";
        } else if (difference < (60*60)) {
            difference /= 60;
            element = "minute"
        } else if (difference < (60*60*24)) {
            difference /= (60*60);
            element = "hour"
        } else if (difference < (60*60*24*31)) {
            difference /= (60*60*24);
            element = "day"
        } else if (difference < (60*60*24*365)) {
            difference /= (60*60*24*31)
            element = "month"
        } else {
            difference /= (60*60*24*365)
            element = "year"
        }
        difference = Math.floor(difference);
        if (difference > 1) {
            element = element + "s"
        }
        return <FormattedMessage id={"fault.timeAgo." + element} values={{'difference': difference}}/>;
    }

    getSyptomsList(presentSymptoms, repeatFaults, assetId) {
        presentSymptoms = presentSymptoms.map(s => {
            let repeatFaultsForSymptom = null;
            if (repeatFaults != null && repeatFaults.length > 0) {
                repeatFaultsForSymptom =
                    this.getRepeatFaults(s, repeatFaults, assetId);
            }
            return <li key={s.id}>{s.name}{repeatFaultsForSymptom}</li>
        })
        return <ul>{presentSymptoms}</ul>
    }

    goToTroubleshooting() {
        const {history, fault, userProfile} = this.props
        if (fault.details.faultConditionState === FAULT_STATES.NEW && !fault.readOnly) {
            this.props.FaultActions.setFaultState(fault.assetId, fault.faultId, FAULT_STATES.IN_PROGRESS, [], null, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
                    history.push(history.location.pathname + "/troubleshooting")
                }
            ).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        } else {
            if (this.state.UIconfig_ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON) {
                this.props.FaultActions.assignUser(fault.assetId, fault.faultId, userProfile.id,
                    userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(
                    () => history.push(history.location.pathname + "/troubleshooting")
                ).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
            } else {
                history.push(history.location.pathname + "/troubleshooting")
            }
        }
    }

    goToWorkplan() {
        const {history} = this.props
        history.push(history.location.pathname + "/dwp")
    }

    getReadOnlyStatus() {
        const {intl, fault} = this.props
        let text = '';
        if (fault.readOnly) {
            text = intl.formatMessage({id: "fault.detail.label.readonly"})
        }
        return <div className='fault-readonly-text'>{text}</div>
    }

    workflowLinkWithModal() {
        const {intl} = this.props
        let image = workflowImageEn
        if (getCurrentLanguage() === 'zh') {
            image = workflowImageZh
        }
        return (
            <div id="workflow-modal-link">
                (
                <Button type="link" content = {intl.formatMessage({id: 'fault.detail.state.workflow'})}
                        onClick={()=> this.setState({workflowModalOpen: true})} />
                <Modal closeIcon={true} onClose={() => this.setState({workflowModalOpen: false})} open={this.state.workflowModalOpen} closeOnDimmerClick={true} className="workflow-modal">
                    <Modal.Header>
                        <FormattedMessage id="fault.detail.label.workflow"/>
                    </Modal.Header>
                    <Modal.Content>
                        <img alt="workflow" src={image}/>
                    </Modal.Content>
                </Modal>
                )
            </div>
        )
    }

    renderAssignButton() {
        const { fault } = this.props
        let assignButton = ""
        if (!immutableFaultState(fault)  && userHasActivity(this.props.userProfile, ACTIVITY_TYPES.TASKS_READ) &&
            !this.isUserAssigned() && !userHasRole(this.props.userProfile, ROLES.OBSERVER)) {
            assignButton =
                <div className="assign-link">
                    (
                    <Button type="link" content="Assign to me" onClick={()=> {
                        this.props.FaultActions.assignToSelf(fault.details.asset.id, fault.details.id,
                            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
                            this.reloadFaultCondition(fault.assetId, fault.faultId)
                            showNotification({translationPropertyKey: 'fault.detail.action.assign.success'})
                        }).catch((err) => {
                            if (err.generalError === false) {
                                showNotification({
                                    translationPropertyKey: 'fault.detail.action.assign.' + err.errorKey,
                                    severity: "critical",
                                });
                            }
                        })}}
                    />
                    )
                </div>
        }
        return assignButton
    }

    setPrimarySymptomAgain() {
        const {fault} = this.props
        const o = {state: 'PRESENT', id: fault.details.primarySymptom.id}
        const assetID = fault.assetId;
        this.state.apiPoint.submitAssetObservations(assetID, [o]).then(response => {
            this.setState({affectedFaults: response, localLoading: false})
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    getSuccessNotification() {
        if (this.state.affectedFaults.length === 0) {
            return null
        }
        const asset = this.state.affectedFaults[0].asset

        return <Notification
            hasIcon={true}
            severity="success"
            onCloseClick={() => this.setState({affectedFaults: []})}>
            <FormattedMessage id="fault.report.submit.success"/>
            <ul>
                {this.state.affectedFaults.map(f => <li key={f.id} className={'state-' + f.faultConditionState}><div className='state-icon' /><div className='state-name'><FormattedMessage id={"fault.detail.state." + f.faultConditionState}/></div>
                    <Link to={
                        userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
                            `/airtime/asset/${asset.id}/faults/${f.id}`
                            :
                            `/assets/${asset.id}/faults/${f.id}`
                    } target="_self"><Button type="link">{getFaultName(f)}</Button></Link></li>)}
                <li className="asset-link"><Link to={`/assets/${asset.id}`}><Button type="link"><FormattedMessage id={"fault.report.asset.faults"} values={{name: asset.name}}/></Button></Link></li>
            </ul>
        </Notification>
    }

    render() {
        const {intl, fault, security} = this.props

        if (fault.error) {
            return <ErrorTitle title={"fault.detail.error."+fault.error} />
        }

        if (!fault.faultId || !fault.details) {
            return null
        }

        let breadcrumbComponent = null
        if (fault.details.name) {
            breadcrumbComponent = <BreadCrumb items={getBreadcrumbItemsFault(fault.details,
                userHasActivity(security.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? intl.formatMessage({id: "admin.tab.only.assets"}) : null,
                null,
                userHasActivity(security.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))} />
        }

        let faultName;
        if (fault.details.name) {
            faultName = fault.details.name + ': ' + fault.details.primarySymptom.name
        }

        let reportedSymptoms = [];
        if (fault.details && fault.details.reportedSymptoms) {
            reportedSymptoms = fault.details.reportedSymptoms
        }

        let repeatFaults = [];
        if (fault.details && fault.details.repeatFaults) {
            repeatFaults = fault.details.repeatFaults
        }

        repeatFaults.sort(orderRepeatFaults);

        let fcCreatedMessage;
        if (fault.createdFaults.length > 0) {
            fcCreatedMessage =
                <Notification
                    className="created-faults-info"
                    hasIcon={true}
                    severity="information"
                >
                    <FormattedMessage id="fault.delete.createdfcs"/>
                    <ul>{fault.createdFaults.map(f => <li key={f.id} className={'state-' + f.faultConditionState}><div className='state-icon' /><div className='state-name'><FormattedMessage id={"fault.detail.state." + f.faultConditionState}/></div>
                        <Link to={
                            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
                                `/airtime/asset/${f.asset.id}/faults/${f.id}`
                                :
                                `/assets/${f.asset.id}/faults/${f.id}`
                        } target="_self"><Button type="link">{getFaultName(f)}</Button></Link></li>)}</ul>
                </Notification>
        }

        const readOnlyMessage = [];
        if (fault.readOnly) {
            readOnlyMessage.push(<Icon key='icon-warning' name="badge-warning"/>)
            readOnlyMessage.push(<FormattedMessage key="readonly" id="fault.detail.troubleshooting.readonly"/>)
            if (isClosedState(fault.details.faultConditionState)) {
                readOnlyMessage.push(<FormattedMessage key="closed" id="fault.detail.troubleshooting.readonly.closed"/>)
            } else {
                if (fault.details.access !== ACCESS.WRITE) {
                    readOnlyMessage.push(<FormattedMessage key="nowrite" id="fault.detail.troubleshooting.readonly.nowrite"/>)
                } else if (!this.isUserAssigned()) {
                    readOnlyMessage.push(<FormattedMessage key="user" id="fault.detail.troubleshooting.readonly.user"/>)
                }
                if (fault.details.faultConditionState === FAULT_STATES.ON_HOLD) {
                    readOnlyMessage.push(<FormattedMessage key="onhold" id="fault.detail.troubleshooting.readonly.onhold"/>)
                }
            }
        }

        // Fault with name starting 'Alert#' and with NEW state will be on UI shown with state 'NEW_ALERT' (this state doesn't really exist in DB)
        let newFaultState = fault.details.faultConditionState
        if (fault.details.name.startsWith('Alert#') && (fault.details.faultConditionState === FAULT_STATES.NEW)) {
            newFaultState = FAULT_STATES.NEW_ALERT;
        }

        fault.details.similarFaultsOnAsset.sort(orderSimilarFaultsAccordingMatch);
        fault.details.similarFaultsOnDifferentAssets.sort(orderSimilarFaultsAccordingMatch);
        const locking = this.state.editingDisabled ? "locked" : "unlocked"
        const configButton =
            <div className="locking-button">
                <Button onClick={() => this.setState({editingDisabled: !this.state.editingDisabled})}
                        disabled={
                            fault.readOnly ||
                            !userHasActivity(security.userProfile, ACTIVITY_TYPES.CONFIG_SYMPTOMS_WRITE) ||
                            immutableFaultState(fault)
                        }
                        className="mobile-max-width-button"
                        type="secondary"
                >
                    {intl.formatMessage({id: 'fault.detail.title.configurationSymptoms.' + locking})}
                </Button>
            </div>
        const reportAgainButton =
            <Button type="primary"
                    content={intl.formatMessage({id: "fault.detail.title.report.primary.symptom"})}
                    onClick={() => {
                        this.setState({localLoading: true});
                        this.setPrimarySymptomAgain();
                    }}
                    className="mobile-max-width-button"
                    disabled={fault.details.canBeReportedAgain !== 'CAN_BE_REPORTED'}
            />
        return (
            <div id="fault-detail" >
                {breadcrumbComponent}
                <Loader loading={this.props.loading || this.state.localLoading}/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {fcCreatedMessage}
                            {this.getSuccessNotification()}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <h2>{faultName}</h2>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12}>
                            <ActionsDropdown reloadFaultCondition={() => this.reloadFaultCondition(fault.assetId, fault.faultId)} troubleshootingNavigation={this.goToTroubleshooting} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <Card className="general">
                                <Card.Header title="General" />
                                <Card.Content>
                                    <Grid>
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                <FormattedMessage id="fault.detail.label.primarysymptom" />
                                            </Grid.Column>
                                            <Grid.Column width={7}>
                                                {fault.details && fault.details.primarySymptom ? fault.details.primarySymptom.name : ''}
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                <FormattedMessage id="fault.detail.label.state" />
                                            </Grid.Column>
                                            <Grid.Column width={7} className={'state-' + newFaultState}>
                                                <div>
                                                    <div className='state-icon' />
                                                    <div className='state-name'>{newFaultState ? intl.formatMessage({id: "fault.detail.state." + newFaultState}) : ''}</div>
                                                    {this.getReadOnlyStatus()}
                                                    {this.workflowLinkWithModal()}
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        {fault.details.assignedUser !== null ?
                                            <Grid.Row>
                                                <Grid.Column width={5}>
                                                    <FormattedMessage id="fault.detail.label.user" />
                                                </Grid.Column>
                                                <Grid.Column width={7} >
                                                    <div className="align-row">
                                                        <div>{fault.details.assignedUser.displayName}</div>
                                                        {this.renderAssignButton()}
                                                    </div>
                                                </Grid.Column>
                                            </Grid.Row>
                                            :
                                            ""
                                        }
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                <FormattedMessage id="fault.detail.label.created" />
                                            </Grid.Column>
                                            <Grid.Column width={7}>
                                                {fault.details.created ? formatDateTime(fault.details.created) : ''}
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                <FormattedMessage id="fault.detail.label.modified" />
                                            </Grid.Column>
                                            <Grid.Column width={7}>
                                                {fault.details.modified ? formatDateTime(fault.details.modified) : ''}
                                            </Grid.Column>
                                        </Grid.Row>
                                        {
                                            isClosedState(fault.details.faultConditionState) ?
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <FormattedMessage id="fault.detail.label.closed" />
                                                    </Grid.Column>
                                                    <Grid.Column width={7}>
                                                        {fault.details.closed ? formatDateTime(fault.details.closed) : ''}
                                                    </Grid.Column>
                                                </Grid.Row>
                                                :
                                                ''
                                        }
                                        {
                                            (fault.details.exportedLL) ?
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <FormattedMessage id="fault.detail.label.exportedLL" />
                                                    </Grid.Column>
                                                    <Grid.Column width={7}>
                                                        <div>
                                                            {formatDateTime(fault.details.exportedLL)}
                                                        </div>
                                                    </Grid.Column>
                                                </Grid.Row>
                                                :
                                                ''
                                        }
                                    </Grid>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12}>
                            {fault.details.faultConditionState === FAULT_STATES.DELETED || isClosedState(fault.details.faultConditionState) ?
                                (fault.details.faultConditionState === FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT ||
                                    fault.details.faultConditionState === FAULT_STATES.CLOSED_DUE_TO_INACTIVITY) ?
                                    <Card className="fill-height troubleshooting-card">
                                        <Card.Header
                                            title={intl.formatMessage({id: "fault.detail.title.report.primary.symptom.again"})}>
                                        </Card.Header>
                                        <Card.Content>
                                            <div className="bottom-right">
                                                {
                                                    fault.details.canBeReportedAgain !== 'CAN_BE_REPORTED' ?
                                                        <Tooltip
                                                            element={<div>{reportAgainButton}</div>}
                                                            content={fault.details.canBeReportedAgain === 'DO_NOT_EXIST' ?
                                                                intl.formatMessage({id: "fault.detail.primary.doNotExist"})
                                                                :
                                                                intl.formatMessage({id: "fault.detail.primary.alreadySetUp"})
                                                            }
                                                            position="top center"
                                                            event="hover"
                                                            hoverable={true}
                                                        />
                                                        :
                                                        reportAgainButton
                                                }

                                            </div>
                                        </Card.Content>
                                    </Card>
                                    :
                                    null
                                :
                                <Card className="fill-height troubleshooting-card">
                                    <Card.Header
                                        title={intl.formatMessage({id: "fault.detail.title.troubleshooting"})}/>
                                    <Card.Content>
                                        {readOnlyMessage}
                                        <div className="bottom-right">

                                            <Button type="secondary"
                                                    content={intl.formatMessage({id: "fault.detail.button.workplan"})}
                                                    onClick={this.goToWorkplan}
                                                    className="mobile-max-width-button"
                                            />
                                            <div className="horizontal-spacer" />
                                            <Button type="primary"
                                                    content={intl.formatMessage({id: "fault.detail.button.troubleshooting"})}
                                                    onClick={this.goToTroubleshooting}
                                                    className="mobile-max-width-button"
                                            />
                                        </div>
                                    </Card.Content>
                                </Card>
                            }
                        </Grid.Column>
                    </Grid.Row>
                    {verifySummaryState(this.props) ?
                        <Grid.Column width={12}>
                            <ExpandableCard title={intl.formatMessage({id: "fault.detail.title.faultSummary"})} content={getFaultSummary(this.props, this.state.closedSelectedReason)}
                                            expandable={this.props.fault.actions.filter(action => action.currentResult !== null && action.currentResult !== CORRECTIVE_ACTION_STATE.NOT_PERFORMED).length > 5}/>
                        </Grid.Column>
                        :
                        null
                    }
                    <Grid.Row id="reported-symptoms">
                        <Grid.Column width={12}>
                            <ExpandableCard title={intl.formatMessage({id: "fault.detail.title.reportedsymptoms"})} content={this.getSyptomsList(reportedSymptoms, repeatFaults, fault.assetId)} expandable={reportedSymptoms.length > 5} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row id="configuration-symptoms">
                        <Grid.Column width={12}>
                            <ExpandableCard title={intl.formatMessage({id: "fault.detail.title.configurationSymptoms.onFault"})}
                                            content={
                                                <ConfigurationSymptoms
                                                    configSymptoms={fault.details.configurationSymptoms}
                                                    disabled={this.state.editingDisabled}
                                                    fault={fault}
                                                />
                                            }
                                            inTitleSection={
                                                fault.details.configurationSymptoms != null &&
                                                fault.details.configurationSymptoms.length > 0 ?
                                                    userHasActivity(security.userProfile, ACTIVITY_TYPES.CONFIG_SYMPTOMS_WRITE) &&
                                                    !immutableFaultState(fault) ?
                                                        configButton
                                                        :
                                                        <Tooltip
                                                            element={configButton}
                                                            content={intl.formatMessage({id: 'fault.detail.title.configurationSymptoms.noRights'})}
                                                            position="top center"
                                                        />
                                                    :
                                                    null
                                            }
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row id="similar-faults">
                        <Grid.Column width={12}>
                            <ExpandableCard title={
                                intl.formatMessage({id: "fault.similarFaults.onAsset"},
                                    {count: fault.details.similarFaultsOnAsset == null ? 0 : fault.details.similarFaultsOnAsset.length})}
                                            content={<SimilarFaultCards faults={fault.details.similarFaultsOnAsset} numberOfAllocatedSymptoms={fault.details.numberOfAllocatedSymptoms}/>}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row id="similar-faults">
                        <Grid.Column width={12}>
                            <ExpandableCard title={
                                intl.formatMessage({id: "fault.similarFaults.onDifferentAssets"},
                                    {count: fault.details.similarFaultsOnDifferentAssets == null ? 0 : fault.details.similarFaultsOnDifferentAssets.length})}
                                            content={<SimilarFaultCards faults={fault.details.similarFaultsOnDifferentAssets} numberOfAllocatedSymptoms={fault.details.numberOfAllocatedSymptoms}/>}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row id="action-log">
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Header title={intl.formatMessage({id: "fault.detail.title.actionlog"})}/>
                                <Card.Content>
                                    <ActionLogTable actionLog={fault.actionLog} currentFaultId={fault.faultId}/>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Loader loading={this.state.commentsLoading}/>
                                <Card.Header title={intl.formatMessage({id: "fault.detail.title.comments"})} />
                                <Card.Content>
                                    <CommentsTable comments={fault.comments} updateComment={this.handleUpdateComment} currentUserId={this.props.security.userProfile.id}/>
                                    <Grid className="new-comment-panel">
                                        <Grid.Row>
                                            <Grid.Column width={12}>
                                                <TextArea
                                                    label={intl.formatMessage({id: "fault.detail.label.comment"})}
                                                    value={this.state.comment} onChange={this.handleCommentChange}
                                                    helperText={intl.formatMessage({id: "fault.detail.comment.warning"})}
                                                    fluid/>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={12}>
                                                <div className="right">
                                                    <Button content={intl.formatMessage({id: "fault.detail.button.save"})} onClick={this.handleSaveComment} disabled={!this.state.comment}/>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

const orderRepeatFaults = (a, b) => {
    if (a.closeDateTime > b.closeDateTime) {
        return -1
    }
    if (a.closeDateTime < b.closeDateTime) {
        return 1
    }
    return 0;
}

const orderSimilarFaultsAccordingMatch = (a, b) => {
    if (a.commonAllocatedSymptoms == null) {
        if (b.commonAllocatedSymptoms == null) {
            return -1;
        }
        return 1;
    }

    if (a.commonAllocatedSymptoms.length > b.commonAllocatedSymptoms.length) {
        return -1
    }
    if (a.commonAllocatedSymptoms.length < b.commonAllocatedSymptoms.length) {
        return 1
    }
    if (a.closeDateTime == null) {
        return -1
    }
    if (b.closeDateTime == null) {
        return 1
    }
    if (a.closeDateTime > b.closeDateTime) {
        return -1
    }
    if (a.closeDateTime < b.closeDateTime) {
        return 1
    }
    return 0;
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultDetail)))
